module.exports = __webpack_public_path__ + "static/img/eyebrows_09.4dee9f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_09.png
// module id = 54eA
// module chunks = 0